import '../../assets/components/SalesBatches/salesBatches.css';const e = "_accordionContent_qgx7k_1", t = "_batchesHeader_qgx7k_3", o = {
  accordionContent: e,
  batchesHeader: t
};
export {
  e as accordionContent,
  t as batchesHeader,
  o as default
};
